import React, { useState } from 'react';
import Link from 'next/link';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useApplyTutorial } from '@components/acca/test/query/useApply';
import { useTermsCheckNewMutation } from '@components/acca/test/query/useTerms';
import AccaModal from '@components/acca/test/modals';
import { TERMS } from '@domain/constant/termsType';
import { AccaModalType } from '@domain/constant/acca/AccaModalType';
import RouterQuery, { UtmOrigin } from '@utils/routeUtil/RouterQuery';
import { V2Route, RouteUrl } from '@utils/routeUtil';

import UrlUtil from '@utils/urlUtil';
import classnames from 'classnames/bind';
import styles from './rightBar.module.scss';
const cx = classnames.bind(styles);

const RightBar = () => {
  const IMG_PATH = '/img/v2/components/accaIntroduce';
  const [modalState, setModalState] = useState<AccaModalType>(null);
  const { data: userInfo } = useUserInfo();
  const isLogin = !!userInfo?.id;
  const { data: tutorialApplyData } = useApplyTutorial(isLogin);
  const { mutateAsync: checkTermsMutateAsync } = useTermsCheckNewMutation();

  // 튜토리얼 페이지 열기
  const onApplyTutorial = async () => {
    const { url, token } = tutorialApplyData;
    const accTutorialUrl = V2Route.getAccaTutorialPage(url);
    UrlUtil.openWindowWithPost(accTutorialUrl, { Authorization: `Bearer ${token}` });
  };

  const onClickTutorialApplyBtn = async () => {
    if (!isLogin) {
      setModalState('LOGIN');
      return;
    }

    // 약관 동의 여부 체크
    const { existsNewTermsAgree } = await checkTermsMutateAsync(TERMS.ACC_TRIAL_PRIVACY_POLICY);
    if (existsNewTermsAgree) {
      setModalState('TUTORIAL_TERMS');
      return;
    }

    onApplyTutorial();
  };

  return (
    //우측 플로팅 바
    <div className={cx('rightBar')}>
      <ul className={cx('menuInner')}>
        <li className={cx('barMenu')}>
          <Link href={RouteUrl.ACCA_TEST_LIST} legacyBehavior>
            <a target="_blank" role="button" className={cx('link', 'acca_intro_floatTest')}>
              <img className={cx('logo')} src={`${IMG_PATH}/icon_acca.png`} alt="실전응시" />
              <span className={cx('linkText')}>실전응시</span>
            </a>
          </Link>
        </li>
        <li className={cx('barMenu')}>
          <a role="button" className={cx('link', 'acca_intro_floatTutorial')} onClick={onClickTutorialApplyBtn}>
            <img className={cx('logo')} src={`${IMG_PATH}/icon_page_list_user.png`} alt="튜토리얼 연습" />
            <span className={cx('linkText')}>튜토리얼 연습</span>
          </a>
        </li>
        <li className={cx('barMenu')}>
          <Link
            href={{ pathname: RouteUrl.ACCA_RESULTS, query: RouterQuery.getUtmSource(UtmOrigin.ACCA) }}
            legacyBehavior
          >
            <a className={cx('link', 'acca_intro_floatResult')} role="button">
              <img className={cx('logo')} src={`${IMG_PATH}/icon_resume_yellow.png`} alt="결과표 확인" />
              <span className={cx('linkText')}>결과표 확인</span>
            </a>
          </Link>
        </li>
      </ul>

      <AccaModal modalState={modalState} setModalState={setModalState} />
    </div>
  );
};

export default RightBar;
